import * as React from 'react';

import LocalShippingRoundedIcon from '@material-ui/icons/LocalShippingRounded';

import styles from './Preview.module.css';

/**
 * Banner to inform users that the dispensary is not accepting orders at this hour
 * 
 * @param {string} dispensaryName - The name of the dispensary
 * @returns 
 */
const PreviewMessage = () => {

  return (
    <div className={styles.msgWrap}>
        <span className={styles.msgPrimary}>
          <span className={styles.icon}>
            <LocalShippingRoundedIcon style={{}}/>
          </span>  
          DELIVERY LAUNCHING SOON!
        </span>
        <span className={styles.msgSecondary}>
          Zip Run is not currently accepting orders.
        </span>
 
    </div>
  )    
}

export default PreviewMessage;